import React from "react";

import { SectionHandlerProps } from "../../../../Types/WatchlistSummary";
import { ScoreBubble } from "../../common/ScoreBubble";
import "./style.scss";

interface SummarySectionProps extends SectionHandlerProps {
  className?: string;
}

export const SummarySection: React.FC<SummarySectionProps> = ({
  sectionData,
  accountName,
  className = "",
}) => {
  const sectionScore = sectionData?.sectionScore || 0;
  const healthFlag = sectionData?.sectionHealthFlag || "N/A";
  const relevanceFlag = sectionData?.sectionRelevanceFlag || "N/A";

  return (
    <div className={`summary-section ${className}`}>
      <div className="section-header">
        <div className="header-left">
          <ScoreBubble
            healthFlag={healthFlag as "R" | "Y" | "G"}
            relevanceFlag={relevanceFlag as "H" | "M" | "L"}
            healthScore={sectionScore}
          />
          <div className="header-title">
            <h3>
              <strong>{accountName}</strong> - <em>Executive Summary</em>
            </h3>
          </div>
        </div>
      </div>
      <div className="section-content">
        <p>Executive Summary section - Score: {sectionScore}</p>
      </div>
    </div>
  );
};
